<top-banner variant="title" [title]="selectedSite?.name"></top-banner>

<div class="main-content">
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="row">
          <div class="col-md-2 cardtabs-wrapper">
            <app-site-tab-menu [site]="selectedSite"></app-site-tab-menu>
          </div>
          <div class="col-md-10">
            <card-section-header
              title="Assets"
              icon="fas fa-list"
              buttonLabel="ADD ASSET"
              buttonIcon="fas fa-plus"
              [showButton]="canAddAssets"
              (buttonClick)="addAsset()">
            </card-section-header>
            <div class="mb-2 animated fadeIn">
            <!-- Filter -->
              <div class="row">
                <div class="col-md-12">
                  <div class="filter-flex-row">
                    <div>
                      <label>Asset Name:</label>
                      <text-filter-box (onFilterTextChanged)="onFilterTextChanged($event)"></text-filter-box>
                    </div>
                    <div *ngIf="isFilterLoading" class="small-spinner">
                      <p-progressSpinner [strokeWidth]="5"></p-progressSpinner>
                    </div>
                  </div>
                  <div class="d-flex justify-content-end">
                    <table-action-bar
                      (toggleColumns)="columnOptionsSidebarVisible = true">
                    </table-action-bar>
                  </div>
                </div>
              </div>
              <!-- Table of results -->
              <div class="row">
                <div class="col-md-12">
                  <p-table [value]="siteAssets" selectionMode="single" [(selection)]="selectedAsset" (onRowSelect)="onRowSelect($event)" [autoLayout]="true"
                      sortField="name" (onSort)="customSort($event)" [sortField]="defaultSortField" [lazy]="true"
                  >
                    <ng-template pTemplate="header">
                      <tr>
                        <th [pSortableColumn]="'locked'" class="table-cell-centered">
                          <i class="fas fa-lock" aria-label="Locked Status"></i>
                          <p-sortIcon [field]="'locked'"></p-sortIcon>
                        </th>
                        <th [pSortableColumn]="'name'">Name
                          <p-sortIcon [field]="'name'"></p-sortIcon>
                        </th>
                        <th *ngIf="tableOptions.visibleColumns.includes('Description')" [pSortableColumn]="'description'">Description
                          <p-sortIcon [field]="'description'"></p-sortIcon>
                        </th>
                        <th *ngIf="tableOptions.visibleColumns.includes('Manufacturer - Model - Rating')">Manufacturer - Model - Rating</th>
                        <th *ngIf="tableOptions.visibleColumns.includes('Restrictions')" >Restrictions</th>
                        <th *ngIf="tableOptions.visibleColumns.includes('Certificates')" >Certificates</th>
                        <th *ngIf="tableOptions.visibleColumns.includes('Categories')" >Categories</th>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-asset>
                      <tr [pSelectableRow]="asset" [ngClass]="asset.lockingWorkOrderId ? 'warning-row' : null">
                        <td class="table-cell-centered">
                          <i *ngIf="asset.locked" class="fas fa-lock color_red-shade1">&nbsp;</i>
                        </td>
                        <td>{{asset.name}}</td>
                        <td *ngIf="tableOptions.visibleColumns.includes('Description')">{{asset.description}}</td>
                        <td *ngIf="tableOptions.visibleColumns.includes('Manufacturer - Model - Rating')">{{ asset.manufacturerModelRatingDisplay }}</td>
                        <td *ngIf="tableOptions.visibleColumns.includes('Restrictions')">
                          <ng-container *ngFor="let item of asset.restrictions">
                            <p><i class="fas fa-exclamation-triangle">&nbsp;</i>{{ item.description }}</p>
                          </ng-container>
                        </td>
                        <td *ngIf="tableOptions.visibleColumns.includes('Certificates')">
                          <ng-container *ngFor="let item of asset.assetCertificates">
                            <span *ngIf="item.expired" class="badge badge-pill badge-warning">{{ item.title }} expired on: {{ item.expiryDate | date: 'mediumDate' }}</span>
                            <span *ngIf="!item.expired" class="badge badge-pill badge-success">{{ item.title }} valid until: {{ item.expiryDate | date: 'mediumDate' }}</span>
                          </ng-container>
                        </td>
                        <td *ngIf="tableOptions.visibleColumns.includes('Categories')">
                          <span *ngFor="let item of asset.assetCategories" class="badge badge-pill badge-success" [style.background-color]="item.color">{{item.name}}</span>
                        </td>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage" let-columns>
                      <tr>
                        <td [attr.colspan]="2 + tableOptions.visibleColumns.length">No assets found</td>
                      </tr>
                    </ng-template>
                  </p-table>
                </div>
              </div>
            </div>
            <div class="card-footer">
              <p-paginator
                #paginator
                [rows]="pagination.size"
                [totalRecords]="pagination.totalRecords"
                [rowsPerPageOptions]="pageSizes"
                (onPageChange)="paginate($event)">
              </p-paginator>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- column options sidebar -->
<p-sidebar [(visible)]="columnOptionsSidebarVisible" position="right" [baseZIndex]="1000000">
  <h6 class="text-primary my-4">Column Options</h6>
  <label>Show:</label>
  <ng-container *ngFor="let col of togglableColumns">
    <div class="form-group">
      <p-checkbox name="togglableColumns" [value]="col.displayName" [(ngModel)]="tableOptions.visibleColumns" (ngModelChange)="saveTableOptions()" [label]="col.displayName"></p-checkbox>
    </div>
  </ng-container>
  <button (click)="resetColumnOptions()" class="mt-4 btn btn-round btn-default btn-simple btn-block">reset to default</button>
</p-sidebar>
